import React, { useContext, useState } from 'react';
import { NavLink } from 'react-router-dom';
import {
  headersButtons,
  mobileNavigationLinks,
  whatsappNumber,
} from '../constants';
import CartIconBlack from '../../assets/CartIconBlack';
import { CartContext } from '../../componentsUpdated/routes/Router';
import { Icon } from '@iconify/react';
import { PhoneData } from './PhoneData';
import { Sidebar } from './Sidebar';
import { AppLauncher } from '@capacitor/app-launcher';

const HoverButton = ({ text = 'home', link = '/' }) => {
  return (
    <NavLink
      to={link}
      activeClassName="activeClass"
      className="group bg-transparent transition duration-300 font-halyard capitalize font-medium text-[17px]/6 self-end !text-midBlack tracking-normal"
    >
      {text}
      <span className="block max-w-0 group-hover:max-w-full transition-all duration-500 h-0.5 bg-black"></span>
    </NavLink>
  );
};

const HealthHeader = () => {
  const { cartItems } = useContext(CartContext);
  const [mobile, setMobile] = useState(false);

  const checkCanOpenUrl = async (url) => {
    const { value } = await AppLauncher.canOpenUrl({ url });
    return value;
  };

  const openUrl = async (url) => {
    if (checkCanOpenUrl()) {
      await AppLauncher.openUrl({
        url,
      });
    } else {
      window.open(url);
    }
  };
  return (
    <>
      <div className="block xl:hidden fixed top-0 z-50">
        <Sidebar
          mobile={mobile}
          setMobile={setMobile}
          navigationLinks={mobileNavigationLinks}
        />
      </div>
      <div
        className={
          'w-full shadow-md bg-white z-50 !px-4 md:!px-10 lg:px-16 2xl:!px-48'
        }
      >
        <div className="max-w-custom mx-auto flex justify-between !py-5">
          <NavLink to={'/'} className="bg-transparent mr-2">
            <img src="/images/new_logo.jpg" className="h-13" alt="logo" />
          </NavLink>
          <img src="/images/zim_flag.png" className="h-13" alt="logo" />

          <div className="flex gap-x-6 items-center">
            <div className="flex gap-x-2 items-center  h-full">
              <div className="gap-x-6 text-lg hidden xl:flex font-semibold">
                {headersButtons?.map((ele, idx) => (
                  <HoverButton key={idx} {...ele} />
                ))}

                <div className="flex justify-center items-center">
                  <img
                    src="/images/three-dots.svg"
                    className="h-4 w-4 rotate-90"
                    alt="three dots icon"
                  />
                </div>
              </div>
              <div className="hidden md:block">
                <PhoneData />
              </div>
            </div>

            <div className="flex md:flex-col md:gap-y-3 lg:gap-y-0 lg:flex-row justify-center items-center">
              <div className="block sm:hidden">
                <PhoneData />
              </div>
              <div className="flex !justify-center !items-center ">
                <div className="hidden md:flex gap-x-6 lg:gap-x-8 items-center ">
                  <NavLink exact to="/register">
                    <div className="  text-xs cursor-pointer text-white font-medium  w-fit !py-2 !px-3  lg:!py-3.5  whitespace-nowrap lg:!px-6.5 text-center uppercase leading-5 bg-darkBlue hover:bg-primaryBlue  tracking-0.5px ">
                      Register for free
                    </div>
                  </NavLink>
                  <NavLink exact to="/login">
                    <div className=" text-xs cursor-pointer text-white font-medium  w-fit !py-2 !px-3  lg:!py-3.5 whitespace-nowrap lg:!px-6.5 text-center uppercase leading-5 bg-darkBlue hover:bg-primaryBlue tracking-0.5px">
                      Sign In
                    </div>
                  </NavLink>
                  <NavLink
                    className="relative  bg-transparent"
                    exact
                    to={`/cart`}
                  >
                    <div className="relative">
                      <CartIconBlack className="size-10" />
                      <span className="absolute -right-1 -top-1 bg-[#132573] size-5 inline-flex rounded-full items-center justify-center text-white text-xs">
                        {(cartItems && cartItems.length) || 0}
                      </span>
                    </div>
                  </NavLink>
                  <div className="hamburger hidden  sm:block xl:hidden">
                    <Icon
                      icon="quill:hamburger-sidebar"
                      className="w-[30px] h-[30px] cursor-pointer"
                      onClick={() => setMobile(!mobile)}
                    />
                  </div>
                </div>
                <div className="flex gap-x-3 justify-center items-center md:hidden">
                  <button
                    className="min-w-8 h-8 flex justify-center items-center bg-[#25D366] rounded-full"
                    // href={`https://wa.me/${whatsappNumber}`}
                    onClick={() => openUrl(`https://wa.me/${whatsappNumber}`)}
                  >
                    <img
                      src="/images/whatsapp.svg"
                      className="size-5"
                      alt="whatsapp icon"
                    />
                  </button>
                  <NavLink
                    className="relative  bg-transparent"
                    exact
                    to={`/cart`}
                  >
                    <div className="relative">
                      <CartIconBlack className="size-8" />
                      <span className="absolute -right-1 -top-1 bg-[#132573] size-5 inline-flex rounded-full items-center justify-center text-white text-xs">
                        {(cartItems && cartItems.length) || 0}
                      </span>
                    </div>
                  </NavLink>
                  <div className="hamburger mobile_dev md:fixed left-8 top-5 z-30">
                    <Icon
                      icon="quill:hamburger-sidebar"
                      className="w-[30px] h-[30px] cursor-pointer"
                      onClick={() => setMobile(!mobile)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HealthHeader;
